import * as yup from 'yup';

export const vendorSchema = yup.object().shape({
  companyName: yup.string().required(),
  emailAddress: yup
    .string()
    .email()
    .required(),
  businessPhone: yup.string().required(),
  ownerName: yup.string().required(),
  address: yup
    .object()
    .shape({
      line1: yup.string().required(),
      zip: yup.string().required(),
      city: yup.string().required(),
      state: yup
        .object()
        .shape({
          abbreviation: yup.string().required()
        })
        .required()
    })
    .required(),
  licenseNumber: yup.string().required(),
  licenseExpiration: yup.string().required(),
  taxId: yup.string().required(),
  w9Status: yup
    .object()
    .shape({
      value: yup
        .string()
        .matches(/(Vendor Validated)/, 'W9 status must be verified')
        .required()
    })
    .required(),
  dispatchLimitPermanent: yup.number().required(),
  hourlyRate: yup.number().required(),
  authoLimit: yup.number().required(),
  sdiExpiration: yup.string().when('sdiWaiver', { is: true, then: yup.string(), otherwise: yup.string().required() }),
  sdiWaiver: yup.bool(),
  'Liability Insurance Certificate': yup
    .bool()
    .oneOf([true], 'Liability Insurance Certificate document is required')
    .required('Liability Insurance Certificate document is required'),
  'Workers Comp Certificate': yup
    .bool()
    .oneOf([true], `Worker's Comp Certificate document is required`)
    .required(`Worker's Comp Certificate document is required`),
  'Contractors State License': yup
    .bool()
    .oneOf([true], `Contractor's State Licensedocument is required`)
    .required(`Contractor's State Licensedocument is required`),
  'Background Check': yup
    .bool()
    .oneOf([true], 'Background Check document is required')
    .required('Background Check document is required'),
  W9: yup
    .bool()
    .oneOf([true], 'W9 document is required')
    .required('W9 document is required'),
  'W9 Verification': yup
    .bool()
    .oneOf([true], 'W9 Verification document is required')
    .required('W9 Verification document is required'),
  'Completed Agreement': yup
    .bool()
    .oneOf([true], 'Completed Agreement document is required')
    .required('Completed Agreement document is required')
});



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-details/vendor-schema.ts